import {Positioner} from "@/utils/positioner";

export class AppPositioner implements Positioner {
    getButtonsBottomY(): number {
        return 8;
    }

    getButtonsLeftX(): number {
        return 5;
    }

    getButtonsRightX(): number {
        return 5;
    }

    getButtonsTopY(): number {
        return 8;
    }

}